module.exports = __webpack_public_path__ + "img/05_Ridge Ties.3025061b.png";